// extracted by mini-css-extract-plugin
export default {"socialButtonGroup":"socialButtonGroup_socialButtonGroup__8mQHj"};